<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left" class="mr-1"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="mx-2">
        <h4 class="mb-0">Персонал</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="loading" @click="handleSubmit()">
              <b-spinner v-if="loading" small></b-spinner>
              <font-awesome-icon icon="save" class="mr-1" />
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-skeleton-wrapper :loading="isBusy">
      <template #loading>
        <b-card no-body>
          <!-- Tabs -->
          <b-tabs card>
            <b-tab title="Персональные данные" disabled/>
            <b-tab title="Паспортные данные" disabled/>
            <b-tab title="Договор" disabled/>
            <b-tab title="Рабочее место" disabled/>
            <b-tab title="Миграционная карта" disabled/>
            <b-tab title="Регистрация" disabled/>
            <b-tab title="Патент" disabled/>
            <b-tab title="Связи" disabled/>
          </b-tabs>
          <b-card border-variant="white">
            <b-row>
              <b-col lg="6">
                <b-card bg-variant="light">
                  <!-- Фамилия -->
                  <b-row class="mt-2 mb-2">
                    <b-col>
                      <b-skeleton width="13%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Имя -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="6%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Отчество -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="14%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Гражданство -->
                  <b-row class="mb-3">
                    <b-col>
                      <b-skeleton width="19%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- ИНН -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="7%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- СНИЛС -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="11%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Статус -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="9%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Название объекта -->
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="27%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="43%"/>
                    </b-col>
                  </b-row>
                  <!-- Примечание -->
                  <b-row class="mb-4">
                    <b-col>
                      <b-skeleton width="19%" height="25%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="70%"/>
                    </b-col>
                  </b-row>
                  <!-- активен -->
                  <b-row>
                    <b-col>
                      <b-skeleton type="input" width="28%" height="50%"/>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-card>
      </template>
      <template #default>
        <b-card no-body>
          <b-form @submit.stop.prevent="handleSubmit">
          <b-tabs card>
            <b-tab title="Персональные данные">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-surname" label="Фамилия">
                      <b-form-input
                        type="text"
                        size="sm"
                        :state="getFieldState('surname')"
                        v-model="newItem.surname"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-name" label="Имя">
                      <b-form-input
                        id="input-name"
                        type="text"
                        size="sm"
                        :state="getFieldState('name')"
                        v-model="newItem.name"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-patronymic" label="Отчество">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.patronymic"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-citizenship" label="Гражданство">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.citizenship"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-inn" label="ИНН">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.inn"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-snils" label="СНИЛС">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.snils"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-status" label="Статус">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.status"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group_location_work_name" label="Название объекта">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.location_work_name"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-note" label="Примечание">
                      <b-form-textarea
                        type="text"
                        size="sm"
                        v-model="newItem.note"
                        trim
                      />
                    </b-form-group>

                    <b-form-checkbox v-model="newItem.active" size="md">Активен / не активен</b-form-checkbox>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Паспортные данные">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-passport-series" label="Серия">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите серию"
                        v-model="newItem.passport_series"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-number" label="Номер">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите номер"
                        v-model="newItem.passport_number"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-birthdate" label="Дата рождения">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.passport_birth_date"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-birthplace" label="Место рождения">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите место рождения"
                        v-model="newItem.passport_birth_place"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-issued-by" label="Кем выдан">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите Кем выдан"
                        v-model="newItem.passport_issued_by"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-issue-date" label="Дата выдачи">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.passport_issue_date"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-department-code" label="Код подразделения">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите Код подразделения"
                        v-model="newItem.passport_department_code"
                      />
                    </b-form-group>

                    <b-form-group id="group-passport-registration-address" label="Адрес регистрации">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        placeholder="Введите Адрес регистрации"
                        v-model="newItem.passport_registration_address"
                      />
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Договор">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-contract-number" label="Номер договора">
                      <b-form-input
                        size="sm"
                        type="number"
                        :disabled="isDisabled"
                        v-model.number="newItem.contract_number"
                      />
                    </b-form-group>
                    <b-form-group id="group-contract-add-date" label="Дата приёма">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.contract_add_date"
                      />
                    </b-form-group>
                    <b-form-group id="group-contract-expiration" label="Дата окончания договора">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.contract_expiration"
                      />
                    </b-form-group>
                    <b-form-group id="group-contract-signed" label="Договор подписан">
                      <b-form-checkbox
                        size="md"
                        :disabled="isDisabled"
                        v-model="newItem.contract_signed">{{ newItem.contract_signed ? "Да" : "Нет" }}</b-form-checkbox>
                    </b-form-group>
                    <b-form-group id="group-contract-received" label="Договор получен">
                      <b-form-checkbox
                        size="md"
                        :disabled="isDisabled"
                        v-model="newItem.contract_received"
                      >
                        {{ newItem.contract_received ? "Да" : "Нет" }}
                      </b-form-checkbox>
                    </b-form-group>
                    <hr/>
                    <b-form-group id="group-contract-dismiss-date" label="Дата увольнения">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.contract_dismiss_date"
                      />
                    </b-form-group>
                    <b-form-group id="group-contract-dismiss-reason" label="Причина увольнения">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.contract_dismiss_reason"
                      />
                    </b-form-group>
                    <hr/>
                    <b-form-group id="group-contract-add-notification" label="Дата отправки уведомления о заключении договора (УВЗ)">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.contract_add_notification"
                      />
                    </b-form-group>
                    <b-form-group id="group-contract-dismiss-notification" label="Дата отправки уведомления о расторжении договора">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.contract_dismiss_notification"
                      />
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Рабочее место">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-organization" label="Организация">
                      <organization-select
                        ref="organization_select"
                        :is-disabled="isDisabled"
                        v-bind:initial-id="newItem.organization_id"
                        v-on:onSelect="onSelectOrg"
                      />
                    </b-form-group>
                    <b-form-group id="group-job-title-select" label="Должность">
                      <job-title-select
                        ref="job_title_select"
                        :is-disabled="isDisabled"
                        v-bind:initial-id="newItem.job_title_id"
                        v-on:onSelect="onSelectJobTitle"
                      />
                    </b-form-group>

                    <b-form-group id="group-department-select" label="Подразделение">
                      <department-select
                        ref="department_select"
                        :is-disabled="isDisabled"
                        v-bind:initial-id="newItem.department_id"
                        v-on:onSelect="onSelectDepartment"
                      />
                    </b-form-group>

                    <b-form-group id="group-okz" label="ОКЗ" description="Общероссийский классификатор занятий">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.okz"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-work-place" label="Место работы">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.work_place"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-work-nature" label="Характер работы">
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="newItem.work_nature"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-salary" label="Оклад">
                      <b-form-input
                        type="number"
                        size="sm"
                        v-model.number="newItem.salary"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-salary-rate" label="Ставка">
                      <b-form-input
                        type="number"
                        size="sm"
                        v-model.number="newItem.salary_rate"
                        trim
                      />
                    </b-form-group>
                    <b-form-group id="group-contract-salary" label="Зарплата по договору">
                      <b-form-input
                        type="number"
                        size="sm"
                        v-model.number="newItem.contract_salary"
                        trim
                      />
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Миграционная карта">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-migration-card-number" label="Миграционная карта">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.migration_card_number"
                      />
                    </b-form-group>

                    <b-form-group id="group-migration-entry-date" label="Дата въезда">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.migration_entry_date"
                      />
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Регистрация">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-registration-place" label="Адрес регистрации">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.registration_place"
                      />
                    </b-form-group>
                    <b-form-group id="group-registration-date" label="Дата регистрации">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.registration_date"
                      />
                    </b-form-group>
                    <b-form-group id="group-registration-expiration" label="Дата окончания регистрации">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.registration_expiration"
                      />
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Патент">
              <b-row>
                <b-col lg="6">
                  <b-card bg-variant="light">
                    <b-form-group id="group-patent-number" label="Патент / ВНЖ">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.patent_number"
                      />
                    </b-form-group>
                    <b-form-group id="group-patent-issue-date" label="Дата выдачи патента">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.patent_issue_date"
                      />
                    </b-form-group>
                    <b-form-group id="group-patent-expiration" label="Дата окончания патента">
                      <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isDisabled"
                        v-model.date="newItem.patent_expiration"
                      />
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Связи">
              <b-row>
                <b-col lg="6" md="12">
                  <b-list-group size="sm">
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                      :variant="getWorkerVariant()"
                    >
                      Исполнитель
                      <div>
                        {{ newItem.worker_id != null ? 'id: ' + newItem.worker_id : '' }}
                      </div>
                    </b-list-group-item>
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                      :variant="getUserVariant()"
                    >
                      Пользователь
                      <div>
                        {{ newItem.user_id != null ? 'id: ' + newItem.user_id : '' }}
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-form>
        </b-card>
      </template>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import staff from "../../network/staff";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import JobTitleSelect from "../Catalogs/JobTitles/JobTitleSelect";
    import DepartmentSelect from "../Catalogs/Departments/DepartmentSelect";


const commonErrorMessage = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие.";

export default {
  name: "Staff",
  components: { OrganizationSelect, JobTitleSelect, DepartmentSelect },
  mixins: [
    staff,
    helpers, dateFormatter
  ],
  data() {
    return {
      newItem: {
        id: 0,
        name: '',
        surname: '',
        patronymic: '',
        citizenship: '',
        inn: '',
        snils: '',
        note: '',
        status: '',
        location_work_name: '',
        passport_series: '',
        passport_number: '',
        passport_birth_date: null,
        passport_birth_place: '',
        passport_issued_by: '',
        passport_issue_date: null,
        passport_department_code: '',
        passport_registration_address: '',
        migration_card_number: "",
        migration_entry_date:	null,
        registration_place:	"",
        registration_date: null,
        registration_expiration: null,
        patent_number: "",
        patent_issue_date: null,
        patent_expiration: null,
        contract_number: 0,
        contract_add_date: null,
        contract_expiration: null,
        contract_signed: false,
        contract_received: false,
        contract_dismiss_date: null,
        contract_dismiss_reason: "",
        contract_add_notification: null,
        contract_dismiss_notification: null,
        job_title_id:	0,
        job_title_name:	"",
        okz: "",
        work_place:	"",
        organization_id: 0,
        organization_name: "",
        work_nature: "",
        salary:	0,
        salary_rate: 1,
        contract_salary: 0,
        active: true,
        department_id:	0,
        department_name:	"",
        worker_id: null
      },
      isBusy: false,
      loading: false,
      isDisabled: false
    }
  },
  async created() {
    this.isBusy = true;
    this.loading = true;
    await this.updateView();
  },
  methods: {
    async updateView() {
      const id = this.$route.params.id;
      if (id != null) {
        await this.getStaff(id);
      } else {
        this.isBusy = false;
        this.loading = false;
      }
    },
    async getStaff(id) {
      this.isBusy = true;
      this.loading = true;
      const result = await this.getStaffById(id);
      this.isBusy = false;
      this.loading = false;

      if (result.data == null) {
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      // Форматируем даты

      this.newItem.passport_birth_date = this.formattedFromServerDate(this.newItem.passport_birth_date);
      this.newItem.passport_issue_date = this.formattedFromServerDate(this.newItem.passport_issue_date);

      this.newItem.migration_entry_date = this.formattedFromServerDate(this.newItem.migration_entry_date);

      this.newItem.registration_date = this.formattedFromServerDate(this.newItem.registration_date);
      this.newItem.registration_expiration = this.formattedFromServerDate(this.newItem.registration_expiration);

      this.newItem.patent_issue_date = this.formattedFromServerDate(this.newItem.patent_issue_date);
      this.newItem.patent_expiration = this.formattedFromServerDate(this.newItem.patent_expiration);

      this.newItem.contract_add_date = this.formattedFromServerDate(this.newItem.contract_add_date);
      this.newItem.contract_expiration = this.formattedFromServerDate(this.newItem.contract_expiration);

      this.newItem.contract_dismiss_date = this.formattedFromServerDate(this.newItem.contract_dismiss_date);
      this.newItem.contract_add_notification = this.formattedFromServerDate(this.newItem.contract_add_notification);
      this.newItem.contract_dismiss_notification = this.formattedFromServerDate(this.newItem.contract_dismiss_notification);

      // Не успевют появиться this.$refs объекты - остаются undefined. Получаем доступ после обновления DOM
      this.$nextTick(async () => {
        if (this.$refs.organization_select != null) {
          await this.$refs.organization_select.configure(this.newItem.organization_id);
        }
        if (this.$refs.job_title_select != null) {
          await this.$refs.job_title_select.configure(this.newItem.job_title_id);
        }
        if (this.$refs.department_select != null) {
          await this.$refs.department_select.configure(this.newItem.department_id);
        }
      });
    },
    onBack() {
      this.goBack();
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const path = '/staffs';
        this.$router.push(path).catch(()=>{});
      }
    },
    async handleSubmit() {
      if (this.newItem.surname === '') {
        this.showSubmitError("Укажите фамилию.");
        return;
      }

      if (this.newItem.name === '') {
        this.showSubmitError("Укажите имя.");
        return;
      }

      this.loading = true;
      const data = Object.assign({}, this.newItem);

      // Форматируем даты
      data.passport_birth_date = this.formattedToServerDate(data.passport_birth_date);
      data.passport_issue_date = this.formattedToServerDate(data.passport_issue_date);

      data.migration_entry_date = this.formattedToServerDate(data.migration_entry_date);

      data.registration_date = this.formattedToServerDate(data.registration_date);
      data.registration_expiration = this.formattedToServerDate(data.registration_expiration);

      data.patent_issue_date = this.formattedToServerDate(data.patent_issue_date);
      data.patent_expiration = this.formattedToServerDate(data.patent_expiration);

      data.contract_add_date = this.formattedToServerDate(data.contract_add_date);
      data.contract_expiration = this.formattedToServerDate(data.contract_expiration);
      data.contract_dismiss_date = this.formattedToServerDate(data.contract_dismiss_date);
      data.contract_add_notification = this.formattedToServerDate(data.contract_add_notification);
      data.contract_dismiss_notification = this.formattedToServerDate(data.contract_dismiss_notification);

      if (data.id > 0) {
        const result = await this.putStaff(data);
        if (result.data == null) {
          this.showError(commonErrorMessage);
          this.loading = false;
          return;
        }
        this.newItem.id = result.data.id;
        this.loading = false;
        this.onBack();
      } else {
        const result = await this.postStaff(data);
        if (result.data == null) {
          this.showError(commonErrorMessage);
          this.loading = false;
          return;
        }
        this.newItem.id = result.data.id;
        this.loading = false;
        this.onBack();
      }
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    async onSelectOrg(orgId) {
      this.newItem.organization_id = orgId;
      if (this.$refs.organization_select != null) {
        this.newItem.organization_name = this.$refs.organization_select.item.name;
      }
    },
    async onSelectJobTitle(id) {
      this.newItem.job_title_id = id;
      if (this.$refs.job_title_select != null) {
        this.newItem.job_title_name = this.$refs.job_title_select.item.name;
      }
    },
    async onSelectDepartment(item) {
      this.newItem.department_id = item.id;
      if (this.$refs.department_select != null) {
        this.newItem.department_name = this.$refs.department_select.item.name;
      }
    },
    getWorkerVariant() {
      return this.newItem.worker_id != null ? 'success' : 'default';
    },
    getUserVariant() {
      return this.newItem.user_id != null ? 'success' : 'default';
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Staff/Staff.vue